import React, { useEffect, useState } from "react";

import {
  FaCoffee,
  FaChild,
  FaClock,
  FaRegCheckCircle,
  FaTv,
  FaCalendarCheck,
  FaTag,
  FaCreditCard,
  FaMedkit,
  FaStar,
  FaHeadset,
} from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import "./MK.css";
import dental1 from "../home/Images/v1.png";
import dental2 from "../home/Images/IMG20240913134831.jpg";
import dental3 from "../home/Images/IMG_20231201_174221.jpg";
import dental4 from "../home/Images/dental2.png";
import test1 from "../home/Images/test2.png";
import test2 from "../home/Images/test.png";
import test3 from "../home/Images/test3.png";
import Slider from "react-slick";
import { IoLocationOutline } from "react-icons/io5";
import { IoTimeOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
export default function MarketingPage() {
  const adminEmail = "tushitasingh@gmail.com";
  const adminEmail2 = "bombaydentalcompany@gmail.com";

  const navigate = useNavigate();

  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "10px",
      padding: "20px",
      borderRadius: "10px",
      maxWidth: "300px",
    },
    googleLogo: {
      width: "50px",
      height: "50px",
    },
    textContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    ratingsText: {
      textAlign: "start",
      fontSize: "16px",
      fontWeight: "bold",
      color: "#333",
      margin: "0px",
      marginBottom: "10px",
    },
    stars: {
      display: "flex",
      gap: "3px",
      marginTop: "5px",
    },
    starIcon: {
      color: "#FFD700",
      fontSize: "18px",
    },
    averageRating: {
      width: "90%",
      fontSize: "24px",
      color: "#333",
      marginTop: "0px",
    },
  };
  const [isLoading, setisLoading] = useState(false);
  const sendEmailToAdmin = async (adminEmail) => {
    const adminEmailPayload = {
      mailto: adminEmail,
      subject: "New Appointment Request",
      body: `
New Appointment Request Details:

Patient Information:
----------------
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}

Message/Reason for Visit:
----------------
${formData.message}


This is an automated notification from the Bombay Dental Company website appointment system.
Please contact the patient to confirm their appointment time and date.
      `,
    };

    return fetch(
      "https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/send_mail.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(adminEmailPayload),
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setisLoading(true);

    try {
      // First API call to send form data
      await fetch(
        "https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/send_us.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      // Send emails to both admins
      const adminEmails = [adminEmail, adminEmail2];
      await Promise.all(adminEmails.map((email) => sendEmailToAdmin(email)));

      // Send confirmation email to user
      const userEmailPayload = {
        mailto: formData.email,
        subject: "Appointment Received",
        body: `Dear ${formData.name},

We have received your appointment request and are currently processing it. Here are the details you provided:

Name: ${formData.name}
Email: ${formData.email}
Phone: 088826 72980
Message: ${formData.message}

Thank you for reaching out to us!

Best regards,
Bombay Dental Company

Address:
Flat No 2 (12, Atur House, 1st Floor,
87, Dr Annie Besant Rd, Worli Naka,
Worli, Mumbai, Maharashtra 400018

Phone: 088826 72980`,
      };

      await fetch(
        "https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/send_mail.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(userEmailPayload),
        }
      );

      navigate("/thank-you");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error("Error processing request:", error);
      window.alert(
        "There was an issue processing your request. Please try again or call us directly."
      );
    } finally {
      setisLoading(false);
    }
  };
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [openQuestion, setOpenQuestion] = useState(null);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: false,
    swipe: false,
    centerMode: true, // This will center the middle item
    focusOnSelect: true, // Automatically focus on the selected item
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const quotes = [
    {
      text: "It has been a great experience for me so far to have my treatment here.Dr. Tushita is very professional and proactive.",
      author: "Rahul",
      // role: "Writer",
      image: test1,
    },
    {
      text: "I recently made a visit to Bombay Dental Company and my experience was so fab! I heard great things about it.",
      author: "Shruti Pandula",
      // role: "Writer",
      image: test3,
    },

    {
      text: "Dr. Tushita is a professional doctor who always advised the right thing to do. I went for root canal and was satisfied with the way I was explained about the problem and the solution.",
      author: "Abhishek Kumar",
      // role: "Writer",
      image: test2,
    },
  ];
  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };
  const barItems = [
    {
      icon: <FaTv size={40} />,
      label: "TVs + Headphone",
    },
    {
      icon: <FaCalendarCheck size={40} />,
      label: "Curated Experience",
    },
    {
      icon: <FaTag size={40} />,
      label: "Parking ",
    },
    {
      icon: <FaCreditCard size={40} />,
      label: "Flexible Bill Plans",
    },
    {
      icon: <FaCoffee size={40} />,
      label: "Beverage Bar",
    },
    {
      icon: <FaChild size={40} />,
      label: "Kids Corner",
    },
    { icon: <FaRegCheckCircle size={40} />, label: "OSHA Approved    " },
    { icon: <FaMedkit size={40} />, label: "Emergency Priority" },
    { icon: <FaClock size={40} />, label: " Time Management  " },
  ];
  const [quoteIndex, setQuoteIndex] = useState(0);
  const nextQuote = () => {
    setQuoteIndex((prevIndex) => (prevIndex + 1) % quotes.length);
  };

  const prevQuote = () => {
    setQuoteIndex(
      (prevIndex) => (prevIndex - 1 + quotes.length) % quotes.length
    );
  };
  const services = [
    { name: "Dental Implants", img: "/images/mk/services/implant.png" },
    { name: "Invisalign & Aligners", img: "/images/mk/services/invisalign.png" },
    { name: "Mouth Rehabilitation", img: "/images/mk/services/mouth.png" },
    { name: "Smile Makeovers", img: "/images/mk/services/smile.png" },
    { name: "Root Canal Treatment", img: "/images/mk/services/root.png" },
  ];
  const { text, author, role, image } = quotes[quoteIndex];

  const faqs = [
    "What is Invisalign?",
    "What is the cost of Invisalign in Worli, Mumbai?",
    "What is the duration of Invisalign treatment in India?",
    "Does Invisalign work for travelling or outstation patients?",
    "What is the best age for getting braces in children?",
    "Are braces painful?",
    "What are the food restrictions with braces?        ",
    "Do teeth go back to same condition after getting braces?",
    "Why do I need a root canal if I don’t have pain?",
    "Why do I need a cap after root canal treatment?",
    "Why do I need to protect the milk teeth of my child if they are going to fall anyway?",
    "Why are dental implants so expensive?",
  ];

  const faqAnswers = [
    "Invisalign is the brand name of the best aligner system in the world, that provides customized, transparent well-fitting clear aligners. Invisalign treatment is much less noticeable than traditional braces or wires; and is extremely predictable as it is based on 25 years of data and 18 million patients worldwide.",
    "The cost of Invisalign in Worli at Bombay dental company depends on the severity of the dental condition and furthermore the category of Invisalign treatment the patient falls in. The cost of Invisalign can range from 1 lac – 3 lacs.",
    "The duration of Invisalign treatment depends on the severity of the dental condition and the category of Invisalign treatment the patient is assigned, that is mild, moderate or severe. The mild category treatment is usually finished in 14 weeks. The moderate category ranges from 6-7 months and the severe category of Invisalign treatment can go up to 12-15 months.",
    " Invisalign works the best for outstation and travelling patients as it is software driven and AI controlled. Most patients at Bombay dental company, Worli, South Mumbai are young adults travelling for work, higher studies, getting married and moving away or visiting from a different city. After getting their Invisalign aligners, patients are put on the Virtual care feature of Invisalign, through which the Invisalign doctor can track their progress virtually through AI, making the treatment outcome successful.",
    "The best age for children to get braces are when all their milk teeth have fallen and been replaced by permanent teeth. This can be anywhere from 11-12.5 years of age. But in some cases, if milk teeth do not fall post this age, they need to be intentionally removed and braces are prescribed to make space for permanent teeth.",
    " Braces treatment at Worli is completely pain-free and pain-managed. The braces are uncomfortable for 1-2 days as the teeth and gums get used to the new addition in the mouth. It is comparable to wearing a new shoe that bites for a day or two, after which we get adjusted to it easily.",
    "The food restrictions with braces are fairly simple. Patients are instructed to take small bites and avoid eating excessively hard and sticky food to avoid breakage of braces and continue the treatment smoothly.        ",
    "Teeth do not go back to the normal condition after removing braces as patients are given retainers which hold the teeth in place till they get fixed in the new position.",
    "When the cavity has extended beyond the superficial surface of the tooth into the nerves and blood vessels, the tooth is completely infected, followed by pain in most cases and no sensation in few cases. This eventually leads to slow breakdown of tooth structure, to restore a tooth for continuing its functions, a root canal treatment followed by crowns is recommended.        ",
    "Root canal treatment involves the cleaning and removal of nerves and blood vessels of the tooth to remove infection. This saves the tooth but leaves it hollow from within. During chewing, the tooth in the opposite arch hits against this hollow tooth continuously which can lead to fracture of the tooth, a dental crown is recommended for to avoid this.",
    "Milk teeth are place holders for guiding permanent teeth into position. If they fall too soon, the future teeth will come only at a fixed time and during this time A) The patient has difficulty in eating without teeth present and B) the remaining teeth migrate into the free space haphazardly leaving no space for future teeth. Hence Pedodontics is a separate field to preserve the precious milk teeth of children.",
    "Dental implants are made of titanium. They are unbreakable and are the next best thing to a natural tooth. They have lifetime warranty and never undergo any kind of wear and tear, outliving the patient himself, making them a wise investment to replace missing teeth.",
  ];

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 20px",
          borderBottom: "1px solid #ccc",
          backgroundColor: "white",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        {/* Logo */}
        <div>
          <img
            className="mk-logo"
            src="https://bombaydentalcompany.com/static/media/logo.154047dc83c7dd48bfa6.png" // Replace with actual logo URL
            alt="BDC Dental Clinic"
          />
        </div>

        {/* Call Section */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <FiPhoneCall className="call-icon" size={24} color="#0047AB" />
          <span
            style={{ fontSize: "1.2rem", fontWeight: "bold", color: "black" }}
          >
            <a
              style={{
                color: "black",
                textDecoration: "none",
              }}
              href="tel:+918882672980"
            >
              088826 72980
            </a>
          </span>
        </div>
      </header>

      <div className="mkt-hero">
        <div className="mkt-left">
          <h1
            style={{
              marginTop: "10px",
            }}
          >
            All Dental Treatments
          </h1>
          <h1>UNDER ONE ROOF!</h1>
          <div>
            <img src="/images/mk/cover.png" alt="Dr. Tushita Singh" />
            <div>
              {[
                {
                  img: "/images/mk/imp.png",
                  text: "Dental Implants",
                },
                { img: "/images/mk/2.png", text: "Root Canal" },
                {
                  img: "/images/mk/3.png",
                  text: "Invisalign & Aligners",
                },
                {
                  img: "/images/mk/4.png",
                  text: "Crowns & Veneers",
                },
              ].map((service, index) => (
                <div
                  className="mkt-service"
                  key={index}
                  style={{
                    width: "90%",
                    display: "flex",
                    height: "fit-content",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <img src={service.img} alt={service.text} />
                  <span>{service.text}</span>
                </div>
              ))}

              <p className="no-cost-emi">
                <span>NO COST EMI</span>
                <span>Available across all Treatments</span>
              </p>
            </div>
          </div>
        </div>
        <div className="mkt-form">
          <form onSubmit={handleSubmit}>
            <div class="input-container">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                id="name"
                required
              />
              <label for="name" class="label">
                Name
              </label>
            </div>
            <div class="input-container">
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                id="phone"
                required
              />
              <label for="phone" class="label">
                Mobile Number
              </label>
            </div>
            <div class="input-container">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                id="email"
                required
              />
              <label for="email" class="label">
                Email
              </label>
            </div>
            <div class="input-container">
              <input
                type="text"
                name="message"
                value={formData.message}
                onChange={handleChange}
                id="message"
                required
                style={{
                  height: "70px",
                }}
              />
              <label for="message" class="label">
                Message
              </label>
            </div>
            <button type="submit" disabled={isLoading}>
              {isLoading ? "Sending..." : "Book"}
            </button>
          </form>
        </div>
      </div>

      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "white",
        }}
      >
        <h2 className="faq-head">Our Key Treatment Services</h2>
        <p style={{ color: "#666", marginBottom: "30px", fontSize: "24px" }}>
          Top Treatments for a Healthier Smile
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "20px",
          }}
        >
          {services.map((service, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
                width: "180px",
              }}
            >
              <img
                src={service.img}
                alt={service.name}
                style={{
                  objectFit: "contain",
                  width: "75px",
                  height: "75px",
                  marginBottom: "10px",
                }}
              />
              <p style={{ color: "#0047AB", fontWeight: "bold" }}>
                {service.name}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="home-sec3">
        <div className="testimonials-container ttc-2 ">
          <div style={styles.container} className="googel-review">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="79"
              height="88"
              viewBox="0 0 79 88"
              fill="none"
            >
              <path
                d="M77.5813 30.4494H74.4667V30.3H39.6667V44.7H61.5191C58.3311 53.0826 49.7645 59.1 39.6667 59.1C26.8545 59.1 16.4667 49.4286 16.4667 37.5C16.4667 25.5714 26.8545 15.9 39.6667 15.9C45.5807 15.9 50.9612 17.9772 55.0579 21.3702L65.9948 11.1876C59.0889 5.1954 49.8515 1.5 39.6667 1.5C18.313 1.5 1 17.619 1 37.5C1 57.381 18.313 73.5 39.6667 73.5C61.0203 73.5 78.3333 57.381 78.3333 37.5C78.3333 35.0862 78.0665 32.73 77.5813 30.4494Z"
                fill="#FFC107"
              ></path>
              <path
                d="M5.45898 20.7438L18.1629 29.418C21.6004 21.4944 29.9253 15.9 39.6674 15.9C45.5814 15.9 50.9619 17.9772 55.0586 21.3702L65.9955 11.1876C59.0896 5.1954 49.8522 1.5 39.6674 1.5C24.8155 1.5 11.9357 9.3066 5.45898 20.7438Z"
                fill="#FF3D00"
              ></path>
              <path
                d="M39.6691 73.5002C49.6567 73.5002 58.7318 69.9416 65.5932 64.1546L53.6258 54.7262C49.7437 57.464 44.9181 59.1002 39.6691 59.1002C29.6119 59.1002 21.0724 53.1296 17.8553 44.7974L5.24609 53.8424C11.6454 65.501 24.6413 73.5002 39.6691 73.5002Z"
                fill="#4CAF50"
              ></path>
              <path
                d="M77.5806 30.4492H74.466V30.2998H39.666V44.6998H61.5185C59.9873 48.7264 57.2052 52.1986 53.6169 54.7276L53.6227 54.724L65.5901 64.1524C64.7433 64.8688 78.3327 55.4998 78.3327 37.4998C78.3327 35.086 78.0659 32.7298 77.5806 30.4492Z"
                fill="#1976D2"
              ></path>
            </svg>
            <div style={styles.textContainer}>
              <p style={styles.ratingsText}>
                2 Lakh + <br /> Verified ratings
              </p>
              <div style={styles.stars}>
                {Array(5).fill(<FaStar style={styles.starIcon} />)}
              </div>
            </div>
            <p style={styles.averageRating}>Average rating of 4.9</p>
          </div>

          <div className="testimonials-slider-container-vv"></div>
          <div
            className="quote-card"
            style={{
              backgroundImage: "none",
              width: "fit-content",
            }}
          >
            <div className="quote-profile">
              <img src={image} alt="Profile" className="profile-img" />
            </div>
            <div
              className="content-main"
              style={{
                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <div className="quote-content">
                <p className="quote-text">"{text}"</p>
                <hr></hr>
                <div className="quote-author">
                  <span className="author-role">{role}</span>
                  <span className="author-name">{author}</span>
                </div>
              </div>
            </div>
            <div className="quote-navigation">
              <button onClick={prevQuote} className="nav-button">
                &#8592;
              </button>
              <button onClick={nextQuote} className="nav-button">
                &#8594;
              </button>
            </div>
          </div>
        </div>
      </div>

      <h1
        className="faq-head"
        style={{
          textAlign: "center",
        }}
      >
        Clinic Photos
      </h1>

      <div className="mktf-someimages">
        <img src="/images/mk/1.jpg" alt="" />
        <img src="/images/mk/3.jpg" alt="" />
        <img src="/images/mk/44.jpg" alt="" />
      </div>

      <h1
        className="faq-head"
        style={{
          textAlign: "center",
        }}
      >
        What Sets Us Apart
      </h1>

      <div className="mkt-someimages">
        <div>
          <img src="/images/mk/1s.png" alt="" />
          <h2>Advanced Technology</h2>
          <p>
            Use of state-of-the-art dental equipment and technology to provide
            precise and effective treatments
          </p>
        </div>
        <div>
          <img src="/images/mk/2s.png" alt="" />
          <h2>Experienced Dentists </h2>
          <p>
            Use of state-of-the-art dental equipment and technology to provide
            precise and effective treatments
          </p>
        </div>
        <div>
          <img src="/images/mk/3s.png" alt="" />
          <h2>Patient-Centric Approach</h2>
          <p>
            Use of state-of-the-art dental equipment and technology to provide
            precise and effective treatments
          </p>
        </div>
        <div>
          <img src="/images/mk/4s.png" alt="" />
          <h2>Comfort and Convenience</h2>
          <p>
            Use of state-of-the-art dental equipment and technology to provide
            precise and effective treatments
          </p>
        </div>
      </div>
      <div className="MarketingPage">
        <div
          className="dental-bar-menu"
          style={{ margin: " 0 0px", backgroundColor: "white" }}
        >
          <h2
            className="menu-title"
            style={{ textAlign: "center", color: " black" }}
          >
            Bombay Dental Company Menu
          </h2>
          <Slider {...sliderSettings}>
            {barItems.map((item, index) => (
              <div
                key={index}
                className="menu-item"
                style={{ textAlign: "center", height: "100%" }}
              >
                <div
                  className="icon"
                  style={{ marginBottom: "10px", color: " #0047AB" }}
                >
                  {item.icon}
                </div>
                <p className="label" style={{ color: " #0047AB" }}>
                  {item.label}
                </p>
              </div>
            ))}
          </Slider>
        </div>
        <div className="visit-us-container">
          <div className="images-container">
            <img src={dental1} alt="Waiting Area" className="image-item" />
            <img src={dental2} alt="Exam Room" className="image-item" />
            <img src={dental3} alt="Sign" className="image-item" />
            <img src={dental4} alt="Lounge" className="image-item" />
          </div>
          <div className="info-container">
            <h1 className="visit">Visit Us</h1>
            <p className="weare">
              We are conveniently located right on the Worli Naka, on the first
              floor of Atur House, opposite the Bharat Petroleum Pump. Our
              guards are very helpful, and free parking is provided easily upon
              asking.
            </p>
            <div className="lhflex">
              <div className="location">
                <h1 className="tp">
                  <IoLocationOutline />
                </h1>
                <p>
                  {" "}
                  Bombay Dental Company
                  <br />
                  Atur House
                  <br />
                  First Floor, Flat no 2<br />
                  Worli Naka, Worli
                  <br />
                  Mumbai 400018
                </p>
                <a
                  href="https://maps.google.com/?q=5Bombay%20Dental%20Company%20Atur%20House%20Worli%20Naka%20Mumbai%20400018"
                  className="directions-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get Directions
                </a>
              </div>
              <div className="hours">
                <h1 className="tp">
                  <IoTimeOutline />
                </h1>
                <p>
                  {" "}
                  Mon-Sat 9 am – 7 pm
                  <br />
                  Sun 10 am – 2 pm
                  <br />
                  Thursday off
                </p>
              </div>
            </div>
          </div>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps?q=5Bombay+Dental+Company+Atur+House+Worli+Naka+Mumbai+400018&output=embed"
              width="100%"
              height="450"
              style={{ border: "8px", borderRadius: "18px " }}
              allowFullScreen
              loading="lazy"
              title="Google Maps Location of Bombay Dental Company"
            />
          </div>
        </div>
        <div className="faq-sec2">
          <h1 className="faq-head">Frequently Asked Questions</h1>
          <div className="faq-section">
            {faqs.map((faq, index) => (
              <div className="faq-item" key={index}>
                <button
                  className="faq-question"
                  onClick={() => toggleQuestion(index)}
                >
                  {faq} <span>{openQuestion === index ? "-" : "+"}</span>
                </button>
                {openQuestion === index && (
                  <div className="faq-answer">
                    <p>{faqAnswers[index]}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="contact-button">
          <FaHeadset className="contact-icon" />
          <div className="contact-text">
            <span className="help-text">Need help?</span>
            <span className="talk-text">Talk to dentist</span>
          </div>
          <a href="tel:08882672980" className="contact-number">
            088826 72980
          </a>
        </div>
      </div>
      <div
        className={`sticky-footer ${isVisible ? "visible" : ""}`}
        style={{
          position: "fixed",
          bottom: "0",
          left: "0",
          width: "100%",
          zIndex: "1000",
          background: "#0047AB",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "15px 0",
          fontSize: "1.2rem",
          fontWeight: "bold",
          transition: "transform 0.3s ease-in-out",
          transform: isVisible ? "translateY(0)" : "translateY(100%)",
        }}
      >
        <FiPhoneCall className="call-icon" size={28} color="white" />
        <span style={{ marginLeft: "10px" }}>
          Get a Call Back from our Dentist
        </span>
      </div>
    </>
  );
}
